import { useEffect, useState } from 'react'
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material'
import { metodoPrograma } from '../../../components/api'
import { CODIGO } from './formulario'

export default function SequenciaDialog({ open, nome, onClose, onChange }) {
  const [estado, setEstado] = useState(null)
  const [valor, setValor] = useState('')
  const [erro, setErro] = useState('')
  const [busy, setBusy] = useState(false)
  useEffect(() => {
    if (!open || !nome) return
    let ativo = true
    setEstado(null)
    setErro('')
    setBusy(true)
    metodoPrograma('consultaSequencia', { nmSequence: nome }, CODIGO)
      .then((res) => {
        if (!ativo) return
        if (!res.status)
          setErro(res.dsErro || 'Não foi possível consultar a sequência.')
        else {
          setEstado(res.existe ? 'existe' : 'nova')
          setValor(res.ultimoDps == null ? '' : String(res.ultimoDps))
        }
      })
      .catch(() => ativo && setErro('Não foi possível consultar a sequência.'))
      .finally(() => ativo && setBusy(false))
    return () => {
      ativo = false
    }
  }, [open, nome])

  const executar = async (metodo, parametros) => {
    setBusy(true)
    setErro('')
    try {
      const res = await metodoPrograma(
        metodo,
        { nmSequence: nome, ...parametros },
        CODIGO,
      )
      if (!res.status) {
        setErro(res.dsErro || 'Não foi possível atualizar a sequência.')
        return
      }
      onChange(res.proximaDps)
      onClose()
    } catch {
      setErro('Não foi possível atualizar a sequência.')
    } finally {
      setBusy(false)
    }
  }

  const inicial = estado === 'nova'
  return (
    <Dialog
      open={open}
      onClose={busy ? undefined : onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Sequência de DPS</DialogTitle>
      <DialogContent>
        <TextField
          label="Sequência PostgreSQL"
          value={nome}
          fullWidth
          margin="normal"
          InputProps={{ readOnly: true }}
        />
        {estado === null && !erro && (
          <Alert severity="info">Consultando sequência...</Alert>
        )}
        {inicial && (
          <Alert severity="info" sx={{ mt: 1 }}>
            Esta sequência ainda não existe. Deseja criá-la? Informe o primeiro
            número da DPS.
          </Alert>
        )}
        {estado === 'existe' && (
          <Alert severity="info" sx={{ mt: 1 }}>
            Informe o último número de DPS utilizado. A próxima emissão usará o
            número seguinte.
          </Alert>
        )}
        {estado && (
          <TextField
            autoFocus
            type="number"
            label={inicial ? 'Número inicial da DPS' : 'Última DPS utilizada'}
            value={valor}
            onChange={(e) => setValor(e.target.value)}
            inputProps={{ min: 1, max: 2147483647, step: 1 }}
            fullWidth
            margin="normal"
          />
        )}
        {erro && (
          <Alert severity="error" sx={{ mt: 1 }}>
            {erro}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          Cancelar
        </Button>
        {inicial && (
          <Button
            variant="contained"
            disabled={
              busy ||
              !valor ||
              Number(valor) < 1 ||
              Number(valor) > 2147483647 ||
              !Number.isSafeInteger(Number(valor))
            }
            onClick={() =>
              executar('criaSequencia', { nrDpsInicial: Number(valor) })
            }
          >
            Criar sequência
          </Button>
        )}
        {estado === 'existe' && (
          <Button
            variant="contained"
            disabled={
              busy ||
              !valor ||
              Number(valor) < 1 ||
              Number(valor) > 2147483647 ||
              !Number.isSafeInteger(Number(valor))
            }
            onClick={() =>
              executar('atualizaSequencia', { ultimoDps: Number(valor) })
            }
          >
            Atualizar número
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
